import { useState } from 'react';
import { Button, Center, Select, Text } from '@mantine/core';
import { closeAllModals, openModal } from '@mantine/modals';
import { i18n } from '@lingui/core';
import { IconChevronDown, IconFileDescription } from '@tabler/icons';
import GenericTemplateName from '../../Molecules/Settings/GenericTemplateName';
import { DataS } from '../../Service/DataS';

// eslint-disable-next-line import/prefer-default-export
export const openCreateDocumentTemplateModal = ({ onCreate }) => {
  openModal({
    size: 'sm',
    title: (
      <Text weight="bolder" size="xl" sx={{ lineHeight: 1.2 }}>
        Dokument-Typ auswählen
      </Text>
    ),
    closeOnEscape: true,
    transition: 'slide-down',
    children: <SelectDocumentTypeAndNameModal finish={onCreate} />,
  });
};

const SelectDocumentTypeAndNameModal = ({ finish }) => {
  const [documentType, setDocumentType] = useState('OFFER');
  const [disableSave, setDisableSave] = useState(false);
  const [newName, setNewName] = useState('');

  const onClickHandler = () => {
    finish(documentType, newName.trim());
    closeAllModals();
  };

  return (
    <>
      <Select
        icon={<IconFileDescription size={20} />}
        label="Dokumentenart"
        data={DataS.getDocumentTypeOptions()}
        styles={{ rightSection: { pointerEvents: 'none' } }}
        rightSection={<IconChevronDown size={14} />}
        rightSectionWidth={25}
        value={documentType}
        onChange={setDocumentType}
        mb="sm"
      />
      <GenericTemplateName
        disableSave={setDisableSave}
        documentType={documentType}
        newName={newName}
        setNewName={setNewName}
      />
      <Center mt="xl">
        <Button mt="md" onClick={onClickHandler} disabled={disableSave} sx={{ width: 200 }}>
          {i18n._('common.apply')}
        </Button>
      </Center>
    </>
  );
};
